/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import {
  UserRequest,
  UserResponse,
} from "../models/userRequestResponse.interface";
import { API_PATH } from "src/environments/config";
import { throwError, of, BehaviorSubject } from "rxjs";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};

@Injectable({
  providedIn: "root",
})
export class SignUpService {
  singUpResponseSubject = new BehaviorSubject({});

  constructor(private http: HttpClient) {}
  public signUp(userRequest: UserRequest) {
    //  const sessionId: string = this.cookieService.get('SESSIONID');
    // httpOptions.headers = httpOptions.headers.set('Authorization', sessionId);

    return this.http.post<UserRequest>(
      `${API_PATH.apis.signup}`,
      userRequest,
      httpOptions
    );
  }

  public verifyOTP(otpobject: any) {
    // const sessionId: string = this.cookieService.get('SESSIONRegID');
    // httpOptions.headers = httpOptions.headers.set('Authorization', sessionId);
    // otpobject.token = this.cookieService.get('SESSIONRegID');
    return this.http.post<any>(`${API_PATH.apis.verifyOTP}`, otpobject);
  }

  private handleError(error) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error("An error occurred:", error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError("Something bad happened; please try again later.");
  }

  public sendSignUpResponse(data: any) {
    console.log(data);

    this.singUpResponseSubject.next(data);
  }
}
